import { render, staticRenderFns } from "./FlightSearch.vue?vue&type=template&id=f8f0efb0&scoped=true&"
import script from "./FlightSearch.vue?vue&type=script&lang=js&"
export * from "./FlightSearch.vue?vue&type=script&lang=js&"
import style0 from "./FlightSearch.vue?vue&type=style&index=0&id=f8f0efb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0efb0",
  null
  
)

export default component.exports